import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import html2pdf from "html2pdf.js";
import config from "../../config";
import JsBarcode from "jsbarcode";

const Label_pdf = () => {
  const { shipment_id } = useParams();
  const hasGenerated = React.useRef(false); // prevent double run

  let userDetail = localStorage.getItem("ship_rocket_user");
  let userData = userDetail ? JSON.parse(userDetail) : {};

  React.useEffect(() => {
    if (!hasGenerated.current) {
      hasGenerated.current = true;
      fetchShipment();
    }
  }, []);

  const fetchShipment = async () => {
    try {
      const res = await axios.post(
        config.apiUrl + "/shipment/print_b2b_label_shipments",
        {
          //   customer_id: userData.customer_id,
          shipment_id: shipment_id,
        },
        { headers: config.headers }
      );

      generatePDF(res.data.output);
    } catch (err) {
      console.log(err);
    }
  };

  const generatePDF = (shipments) => {
    let htmlContent = "";

    shipments.forEach((sub) => {
      console.log("sub -== ", sub);
      const barcodes =
        sub.barcodeList?.length > 0
          ? sub.barcodeList
          : sub.b2b_waybills?.length > 0
          ? sub.b2b_waybills
          : [];
      const totalPkgs = barcodes.length || 1;

      barcodes.forEach((barcode, index) => {
        const canvas = document.createElement("canvas");

        JsBarcode(canvas, barcode, {
          format: "CODE128",
          width: 2,
          height: 80,
          displayValue: false,
        });

        const barcodeBase64 = canvas.toDataURL("image/png");

        const canvasVertical = document.createElement("canvas");

        JsBarcode(canvasVertical, barcode, {
          format: "CODE128",
          width: 2,
          height: 80,
          displayValue: false,
        });

        const barcodeVertical = canvasVertical.toDataURL("image/png");

        htmlContent += `
        <!DOCTYPE html>
        <html>
        
        <head>
            <meta charset="UTF-8">
            <title>Label</title>
        </head>
        
        <body style="margin:0;padding:0;font-family:Arial,Helvetica,sans-serif;">
        
            <div style="width:4in;height:4in;border:2px solid #000;box-sizing:border-box;">
        
                <table style="width:100%;border-collapse:collapse;height:100%;">
        
                    <tr>
                        <td colspan="3"
                            style="border-bottom:1px solid #000;text-align:center;font-weight:bold;font-size:18px;padding:4px;">
                            MOJOSHIP
                        </td>
                    </tr>
        
                    <tr>
                        <td colspan="3" style="border-bottom:1px solid #000;text-align:center;padding:6px;">
        
                            <img src="${barcodeBase64}" style="width:90%;height:50px;"><br>
        
                            <span style="font-size:14px;">${barcode}</span>
        
                        </td>
                    </tr>
        
                    <tr style="height:90px;">
        
                        <td style="border-right:1px solid #000;border-bottom:1px solid #000;padding:6px;width:45%;">
                            <div style="font-size:12px;">From :</div>
                            <div style="font-size:20px;font-weight:bold;">${
                              sub?.sender?.[0]?.city || "N/A"
                            }</div>
                        </td>
        
                        <td style="border-right:1px solid #000;border-bottom:1px solid #000;padding:6px;width:45%;">
                            <div style="font-size:12px;">To :</div>
                            <div style="font-size:20px;font-weight:bold;">${
                              sub?.receiver?.[0]?.city || "N/A"
                            }</div>
                        </td>
        
                        <td rowspan="3" style="text-align:center;width:10%;padding:2px;">
        
                            <img src="https://bwipjs-api.metafloor.com/?bcid=code128&text=${barcode}&scale=2&rotate=R&height=10" style="width:55px;height:160px;">
        
        </td>
        
                    </tr>
        
                    <tr>
        
                        <td style="border-right:1px solid #000;padding:6px;">
                            <div style="font-size:12px;">Docket No :</div>
                            <div style="font-size:20px;font-weight:bold;">${
                              sub.cnote
                            }</div>
                        </td>
        
                        <td style="padding:6px; border-right:1px solid #000;">
                            <div style="font-size:12px;">Seq / No Of Pkgs:</div>
                            <div style="font-size:18px;font-weight:bold;"> ${
                              index + 1
                            } / ${totalPkgs}</div>
                        </td>
        
                    </tr>
        
                </table>
        
            </div>
        
        </body>
        
        </html>
        `;
      });
    });

    const element = document.createElement("div");
    element.innerHTML = htmlContent;

    // ✅ CRITICAL FIX
    document.body.appendChild(element);

    const opt = {
      margin: 0,
      filename: "shipping-label.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: [4, 4] },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        document.body.removeChild(element); // cleanup
      });
  };

  return null; // 👈 NOTHING RENDERED
};

export default Label_pdf;
